import Fetch, { FetchPublic } from "./index";
export const getAssistantPlan = async (id) => {
  if (!id)
    return Promise.reject("failed to read id");

  return Fetch("/assistant-plan/" + id)
}

export const getAssistantPlans = async (filters) => {
  const filter = new URLSearchParams(filters).toString();

  return Fetch(`/assistant-plan?${filter}`)
}

export const updateAssistantPlan = async (id, data) => {
  return Fetch(
    '/assistant-plan/' + id,
    {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      }
    },
  )
}

export const createAssistantPlan = async (data) => {
  return Fetch(
    '/assistant-plan/',
    {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      }
    },
  )
}

export const getAvailablePrices = async () => {
  return FetchPublic('/assistant-plan/available-prices')
}

export const subscribeAssistantPlan = async (id, data) => {
  return Fetch(
    `/assistant-plan/${id}/subscribe`,
    {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json"
      }
    },
  )
}

export const subscribeFreePlan = async (id, data) => {
  return Fetch(
    `/assistant-plan/${id}/subscribe-plan`,
    {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json"
      }
    },
  )
}

export const cancelAssistantPlan = async (data) => {
  return Fetch(
    '/assistant-plan/cancel-plan',
    {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      }
    },
  )
}
